export default __webpack_public_path__ + "static/media/websitedevelopment.0da963a9.gif";